// NPM
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { isNil, isEmpty } from 'lodash';
import { useRecoilState } from 'recoil';

// ATOM
import { emailAtom } from 'Recoil/email.atom';

// UTILS
import errorHandler from 'Utils/error-handler';

// SERVICE
import { sendEmailCorporate } from 'Services/email.services';

// ANT COMPONENT
import { Space, Divider } from 'antd';
import { BasicModal, Button } from '@life-line-lab/components-react';

// COMPONENTS
import CorporateOrderForm from 'Components/corporate-order-form';
import { toaster } from 'Helpers/toaster';

// STYLE
import './corporate-order.scss';

let recaptchaToken="";

const CorporateOrderPage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const [modalState, setModalState] = useState<any>({ isOpen: false });
  const [state, setState] = useRecoilState(emailAtom);

useEffect(() => {
  //Add reCaptcha
  const script = document.createElement("script")
      script.src = `${process.env.RECAPTCHA_API_URL}?render=${process.env.RECAPTCHA_SITE_KEY}`
      // script.addEventListener("load", handleReCaptcha)
      document.body.appendChild(script).onsubmit
},[])

  const handleSubmit = async (data: any) => {
    window.grecaptcha.ready(_ => {
      window.grecaptcha
        .execute(process.env.RECAPTCHA_SITE_KEY, { action: "onClick" })
        .then(async(responseToken) => {
            recaptchaToken = responseToken
            setState(prevState => ({ ...prevState, status: { ...prevState.status, send: 'loading' } }));

            try{
              const emailResult = await sendEmailCorporate({...data,recaptchaToken: recaptchaToken, recaptchaSite: process.env.ACCOUNT_TYPE});

              if(emailResult){
                setState(prevState => ({ ...prevState, status: { ...prevState.status, send: 'idle', error: {} } }));
                toaster(
                    'success',
                    <div dangerouslySetInnerHTML={{
                        __html: t('toaster.supportSuccess')
                    }} />
                )
                history.push('/');
              }else{
                setState(prevState => ({ ...prevState, status: { ...prevState.status, send: 'idle' } }));
                toaster('error', t('toaster.supportFailed'));
              }

            }catch(err){
              setState(prevState => ({ ...prevState, status: { ...prevState.status, send: 'idle' } }));
              toaster('error', t('toaster.supportFailed'));

              const { error } = err.response?.data || {};
              if (!isEmpty(error)) {
                const { value, code, message, stack } = await errorHandler.response(error);
                return { error: { value, code, message, stack }};
              }
              else {
                console.log(err.message)
                return { error: { message: err.message }};
              }
            }
        })
    })


  }

  const onSuccess = () => {
    setState(prevState => ({ ...prevState, status: { ...prevState.status, send: 'idle' } }));
    toaster(
      'success',
      <div dangerouslySetInnerHTML={{
        __html: t('toaster.supportSuccess')
      }} />
    );
    history.push('/');
  }

  // const handleModalOpen = () => {
  //   setModalState({ isOpen: true });
  // }

  // const handleModalClose = () => {
  //   setModalState({ isOpen: false });
  // }

  return (
    <React.Fragment>
      <Helmet>
        <title>
          Corporate Order Form - Covid-19 Self-Test Kits and Services
        </title>
        <meta name="robots" content="noindex"/>
      </Helmet>

      <div className="corporate-order-page">
        <div className="corporate-order-page--main">
          <div className="corporate-order-page--container">
            <div className="corporate-order-page--form">
              <div
                className="corporate-order-page--form-title"
                dangerouslySetInnerHTML={{
                  __html: t('txt.corporateTitle')
              }}/>

              <div className="corporate-order-page--form-description">
                <Space direction="vertical" size="middle">
                  <div>
                    {t('txt.corporateDescriptionOne')}
                  </div>

                  <div>
                    {t('txt.corporateDescriptionTwo')}
                  </div>

                  <div>
                    {t('txt.corporateDescriptionThree')}
                  </div>

                  <div dangerouslySetInnerHTML={{ __html: t('txt.corporateDescriptionFour') }}/>

                  <div className="mb-50">
                    {t('txt.corporateDescriptionFive')}
                  </div>
                </Space>
              </div>

              <CorporateOrderForm
                status={state.status.send}
                expectedError={state.error}
                onSubmit={handleSubmit}
                onSuccess={onSuccess}
              />

            </div>
            <div className="corporate-order-page--bot"></div>
          </div>
        </div>
      </div>

      {/* <BasicModal
        title="Notis / Notice"
        isOpen={modalState.isOpen}
        isClosable={false}
        isMaskClosable={false}
        onClose={handleModalClose}
        width={ 800 }
      >
        <div style={{ fontSize: '18px' }}>
          <p>Pengguna yang dihormati,</p>

          <p>
            Kit ujian diri tidak tersedia untuk penjualan online buat sementara waktu.
            Penjual untuk alat ujian diri ini, Salixium, Gmate, Juschek, LongSee, All Test
            dan Beright sedang bekerjasama dengan pihak berkuasa yang berkaitan untuk
            memastikan ianya tersedia secepat mungkin.
          </p>

          <p>
            Bagi pelanggan yang sudah memberi pesanan, anda akan dihubungi seperti yang disahkan.
            Kami akan menindaklanjuti e-mel pengesahan dengan segera.
          </p>

          <p>
            Bagi mereka yang memerlukan alat ujian diri dengan segera, anda boleh membeli di farmasi
            komuniti dan fasiliti kesihatan lain. Amalkan penjarakan sosial dengan selamat dan ikuti
            SOP selalu di kawasan anda. Sila utamakan  keselamatan anda dan kami berharap untuk
            beroperasi dalam masa terdekat.
          </p>

          <p>
            Untuk pengetahuan lanjut, mengenai ujian kendiri sila layari laman web MDA di <a href="https://portal.mda.gov.my" target="_blank">
            https://portal.mda.gov.my</a>
          </p>

          <p>
            Lindungi Diri <br />
            Pelayanan Pelanggan <br />
            <strong>Pharma2u.co</strong><br />
            #KitaJagaKita
          </p>

          <Divider />

          <p>Dear users</p>

          <p>
            The self test kits are not available for online sales temporarily.
            The merchants for these self test kits, Salixium, Gmate, Juschek, LongSee,
            All Test and Beright are working with the relevant authorities on ensuring
            they are available  as soon as possible.
          </p>

          <p>
            For customers whom have successfully sent your enquiries, We will follow up
            with confirmation email as soon as possible.
          </p>

          <p>
            For those who need the self test kits urgently, you can purchase at your community
            pharmacies and health facilities. Please practice safe distancing and follow the
            SOPs always at your district. Stay safe and we hope to be of service to you soon.
          </p>

          <p>
            For more information on self test kits, please visit <a href="https://portal.mda.gov.my" target="_blank">
            https://portal.mda.gov.my</a>
          </p>

          <p>
            Stay Safe<br />
            Customer Service,<br />
            <strong>Pharma2u.co</strong><br />
            #KitaJagaKita
          </p>

          <div className="">
            <Button
              isLoading={status === "loading"}
              type="primary"
              label={t('action.ok')}
              size="large"
              onClick={handleModalClose}
            />
          </div>
        </div>

      </BasicModal> */}
    </React.Fragment>
  )
}

export default CorporateOrderPage;
